import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { ErrorHttpResponse, SuccessHttpResponse } from '../../../models/https';
import { ScheduleDisputeRecord } from '../../../models/schedules/schedule.model';
import useHttps from '../../useHttps';

// D30: the consent and notices behind one scheduled charge. Loaded on demand,
// since most transactions are never disputed.
const useDisputeRecord = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const [record, setRecord] = useState<ScheduleDisputeRecord | null>(null);

  const load = (reference: string) =>
    request(
      { url: `api/v1/admin/schedules/disputes/${reference}`, method: 'get' },
      ({ data }: SuccessHttpResponse<ScheduleDisputeRecord>) => setRecord(data),
      setLoading,
      (err: AxiosError<ErrorHttpResponse>) =>
        toast.error(err?.response?.data?.message ?? 'Failed to load the dispute record')
    );

  return { record, loading, load };
};

export default useDisputeRecord;
